module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header', {
    staticClass: "sticky"
  }, [_c('div', {
    staticClass: "video-body"
  }, [(_vm.osName == 'android') ? [_c('video', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowVideo && !_vm.isShowComplete),
      expression: "isShowVideo && !isShowComplete"
    }],
    attrs: {
      "id": "topic_video",
      "src": _vm.video.src,
      "preload": "auto",
      "width": "100%",
      "height": "100%",
      "controls": ""
    },
    on: {
      "click": function($event) {
        _vm.addView($event)
      }
    }
  }), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isShowVideo && !_vm.isShowComplete),
      expression: "!isShowVideo && !isShowComplete"
    }],
    staticClass: "video-mask",
    style: ('background-image:url(' + _vm.video.poster + ')'),
    on: {
      "click": function($event) {
        _vm.playVideo(_vm.video.href)
      }
    }
  }, [_c('i')])] : [_c('video', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowVideo),
      expression: "isShowVideo"
    }],
    attrs: {
      "id": "topic_video",
      "src": _vm.video.src,
      "preload": "auto",
      "width": "100%",
      "height": "100%",
      "controls": ""
    },
    on: {
      "click": function($event) {
        _vm.addView($event)
      }
    }
  }), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isShowVideo),
      expression: "!isShowVideo"
    }],
    staticClass: "video-mask",
    style: ('background-image:url(' + _vm.video.poster + ')'),
    on: {
      "click": function($event) {
        _vm.playVideo(_vm.video.href)
      }
    }
  }, [_c('i')])], _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowComplete),
      expression: "isShowComplete"
    }],
    staticClass: "video-complete-mask"
  }, [_c('img', {
    staticClass: "bg",
    attrs: {
      "src": _vm.video.poster
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "cont",
    class: _vm.noticeList.length ? '' : 'none-list'
  }, [(_vm.noticeList.length) ? _c('h5', [_vm._v("视频中提到" + _vm._s(_vm.noticeList.length == 1 ? '' : '(' + _vm.noticeList.length + ')'))]) : _vm._e(), _vm._v(" "), (_vm.noticeList.length) ? _c('slider', {
    attrs: {
      "pages": _vm.pages,
      "sliderinit": _vm.sliderinit,
      "app-name": _vm.appName
    }
  }) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "btn-replay",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.playVideo(_vm.video.href)
      }
    }
  })], 1)])], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowForward),
      expression: "isShowForward"
    }],
    staticClass: "forward-app"
  }, [(_vm.isFromMiniProgram) ? _c('a', {
    staticClass: "forward"
  }, [_c('span', [_vm._v("去大众点评中观看，找店更方便")])]) : _c('a', {
    staticClass: "forward",
    on: {
      "click": function($event) {
        _vm.jumpToVideo(_vm.video.href)
      }
    }
  }, [_c('span', [_vm._v("去大众点评中观看，找店更方便")]), _vm._v(" "), _c('em', {
    staticClass: "arrow"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "video-header"
  }, [_c('div', {
    staticClass: "video-info",
    class: {
      noforward: !_vm.isShowForward
    }
  }, [_c('div', {
    staticClass: "video-content"
  }, [(!_vm.isFromMiniProgram) ? _c('a', {
    on: {
      "click": function($event) {
        _vm.jumpToVideo(_vm.video.href)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "video-title"
  }, [_vm._v(_vm._s(_vm.video.title))]), _vm._v(" "), _c('div', {
    staticClass: "video-count"
  }, [_c('span', [_vm._v(_vm._s(_vm._f("datetime")(_vm.video.createTime, '.')))]), _vm._v(" "), _c('span', [_vm._v("播放次数" + _vm._s(_vm.video.count))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowAuthor),
      expression: "isShowAuthor"
    }],
    staticClass: "author-info"
  }, [(_vm.isFromMiniProgram) ? _c('a', {
    staticClass: "forward"
  }, [_c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.author.imgSrc,
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "author-name"
  }, [_vm._v(_vm._s(_vm.author.name))])]) : _c('a', {
    staticClass: "forward",
    attrs: {
      "href": _vm.author.href
    }
  }, [_c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.author.imgSrc,
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "author-name"
  }, [_vm._v(_vm._s(_vm.author.name))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isShowFollow),
      expression: "!isShowFollow"
    }],
    staticClass: "notice"
  }, [_c('i'), _vm._v("关注")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowFollow),
      expression: "isShowFollow"
    }],
    staticClass: "notice nofollow"
  }, [_vm._v("已关注")])])])]), _vm._v(" "), (!_vm.isFromMiniProgram) ? [_c('shopList', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowNoticeList),
      expression: "isShowNoticeList"
    }],
    attrs: {
      "os-name": _vm.osName,
      "isShowLoading": _vm.isShowLoading,
      "noticeList": _vm.noticeList,
      "app-name": _vm.appName
    }
  })] : _vm._e(), _vm._v(" "), _c('relateVideos', {
    attrs: {
      "videoId": _vm.videoId,
      "isFromMiniProgram": _vm.isFromMiniProgram
    }
  }), _vm._v(" "), (_vm.showComment) ? _c('comment', {
    attrs: {
      "isFromMiniProgram": _vm.isFromMiniProgram,
      "detailHref": _vm.video.href
    }
  }) : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2bf5b126!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/videoPlayer.vue
// module id = 605
// module chunks = 10